import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { evaluatePublicRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsPublicEvaluationService';
import { transformToLegacyPurchaseMotionsShape } from './transformToLegacyPurchaseMotionsShape';
const noAuthChirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const getPublicAppLegacyPurchaseMotionsResponse = requestedLocations => {
  var _COUNTRY_CODE_FROM_LO;
  return noAuthChirpClient.call(evaluatePublicRpc, {
    request: {
      locations: requestedLocations,
      productApiNames: [],
      requestedCountryCode: ((_COUNTRY_CODE_FROM_LO = window.COUNTRY_CODE_FROM_LOCALE) === null || _COUNTRY_CODE_FROM_LO === void 0 ? void 0 : _COUNTRY_CODE_FROM_LO.toUpperCase()) || undefined
    }
  }).then(purchaseMotionsResponse => {
    return {
      locations: transformToLegacyPurchaseMotionsShape(requestedLocations, purchaseMotionsResponse)
    };
  });
};